import _extends from "@babel/runtime/helpers/esm/extends";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-unused-expressions */
import React, { useState } from 'react';
import { Components as SidebarComponents } from './SidebarMenu.style';
import Icon from '../../Icon';
import useOnClickOutside from 'use-onclickoutside';
import SidebarExpandedMenu from './SidebarExpandedMenu';
import SidebarCollapsedMenu from './SidebarCollapsedMenu';
import { customImagePattern } from '../../../utils/helpers';
const SidebarList = _ref => {
  let {
    activeNav,
    items,
    isExpanded,
    showLabelOnCollapse,
    theme,
    minWidth,
    onNavClick
  } = _ref;
  const subMenuRef = React.useRef(null);
  const [selectedMenuItems, setSelectedMenuItems] = useState([]);
  const onSubMenuOutsiteClick = () => {
    onCollapseSubMenu();
  };
  useOnClickOutside(subMenuRef, onSubMenuOutsiteClick);
  const onMenuItemClick = itemId => {
    selectedMenuItems.includes(itemId) ? setSelectedMenuItems(prevActiveSubMenus => prevActiveSubMenus.filter(item => item !== itemId)) : setSelectedMenuItems(prevActiveSubMenus => [].concat(_toConsumableArray(prevActiveSubMenus), [itemId]));
  };
  const onCollapseSubMenu = menuActiceItems => {
    (menuActiceItems === null || menuActiceItems === void 0 ? void 0 : menuActiceItems.length) ? setSelectedMenuItems(menuActiceItems) : setSelectedMenuItems([]);
  };
  return _jsx(SidebarComponents.MenuWrapper, _extends({
    isExpanded: isExpanded
  }, {
    children: _jsx(SidebarComponents.MenuList, {
      children: items.map((item, idx) => {
        const {
          id,
          icon,
          title,
          subMenu
        } = item;
        const isIconCustomImage = typeof icon === 'string' && customImagePattern.test(icon);
        const isActiveNav = activeNav === id;
        const isSubMenuActive = selectedMenuItems.includes(id || '');
        return _jsxs(SidebarComponents.MenuListItem, _extends({
          className: "sidebar-menu",
          themeMode: theme,
          isSubMenuActive: isSubMenuActive,
          onClick: e => {
            var _a;
            e.stopPropagation();
            e.preventDefault();
            if ((_a = item === null || item === void 0 ? void 0 : item.subMenu) === null || _a === void 0 ? void 0 : _a.length) {
              onMenuItemClick(id || '');
            } else {
              onNavClick && onNavClick(item.path, item, e);
              onCollapseSubMenu();
            }
          }
        }, {
          children: [_jsxs(SidebarComponents.MenuItemContent, _extends({
            isExpanded: isExpanded,
            isActiveNav: isActiveNav,
            themeMode: theme
          }, {
            children: [_jsxs(SidebarComponents.ContentWrapper, _extends({
              isExpanded: isExpanded,
              themeMode: theme
            }, {
              children: [typeof icon !== 'string' ? icon : isIconCustomImage ? _jsx(SidebarComponents.CustomImageIcon, {
                src: icon,
                alt: 'Loading'
              }) : _jsx(Icon, {
                name: icon,
                size: "20"
              }), (isExpanded || showLabelOnCollapse) && _jsx(SidebarComponents.ItemTitle, _extends({
                variant: isExpanded ? 'body1' : 'body2',
                isExpanded: isExpanded,
                themeMode: theme
              }, {
                children: title || 'N/A'
              }))]
            })), isExpanded && (subMenu === null || subMenu === void 0 ? void 0 : subMenu.length) && _jsx(SidebarComponents.DropdownIcon, {
              name: isSubMenuActive ? 'chevron-down' : 'chevron-right',
              themeMode: theme
            })]
          })), isSubMenuActive && (subMenu === null || subMenu === void 0 ? void 0 : subMenu.length) ? isExpanded ? _jsx(SidebarExpandedMenu, {
            activeNav: activeNav,
            item: item,
            selectedMenuItems: selectedMenuItems,
            theme: theme,
            onNavClick: onNavClick,
            onMenuItemClick: onMenuItemClick,
            onCollapseSubMenu: onCollapseSubMenu
          }) : _jsx(SidebarCollapsedMenu, {
            activeNav: activeNav,
            item: item,
            selectedMenuItems: selectedMenuItems,
            subMenuRef: subMenuRef,
            minWidth: minWidth,
            theme: theme,
            onNavClick: onNavClick,
            onMenuItemClick: onMenuItemClick,
            onCollapseSubMenu: onCollapseSubMenu
          }) : _jsx(_Fragment, {})]
        }), idx);
      })
    })
  }));
};
export default SidebarList;